import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { LocalStorageItemsService } from './local-storage-items.service';
import { initSocket } from '../shared/socket';
@Injectable({
  providedIn: 'root',
})
export class SocketService implements OnInit {
  readonly data_importing = new BehaviorSubject({});
  userCompanies: any;
  socketIO: any;

  constructor(private localStorageItemsService: LocalStorageItemsService) {}
  ngOnInit() {}
  connectMe() {
    this.socketIO = initSocket();
    this.socketIO.on('connect', () => {
      console.log(this.socketIO, '=============', 'Connected to the server');
    });
    this.socketIO.onAny((event: any, ...args: any) => {
      const data = args?.[0] || {}; // safest way

      console.log('Received event:', data?.message);

      const message = data?.message;

      if (!message) {
        console.warn('Socket event received without message:', data);
        return;
      }
      if (data?.message?.app_name == environment.module) {
        console.log(data?.message, ' pass ============= ');
        switch (data?.message?.message) {
          case 'employee-imported':
            this.data_importing.next(data?.message);
            break;
          case 'existed-employee':
            this.data_importing.next(data?.message);
            break;
        }
      }
    });

    this.socketIO.on('error', (error: any) => {
      console.error('Socket error:', error);
    });
  }
  disconnect() {}
}
